import { render, staticRenderFns } from "./CourseTemplatePage.vue?vue&type=template&id=748d39bb&scoped=true&"
import script from "./CourseTemplatePage.vue?vue&type=script&lang=js&"
export * from "./CourseTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./CourseTemplatePage.vue?vue&type=style&index=0&id=748d39bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d39bb",
  null
  
)

export default component.exports